(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('OrderBagServiceItemListController', OrderBagServiceItemListController);

    OrderBagServiceItemListController.$inject = ['$scope', '$state', 'OrderBagServiceItem', 'OrderBagServiceItemSearch', 'ParseLinks', 'AlertService', 'OrderBagServiceItemCustom', 'OrderBagCustom'];

    function OrderBagServiceItemListController($scope, $state, OrderBagServiceItem, OrderBagServiceItemSearch, ParseLinks, AlertService, OrderBagServiceItemCustom, OrderBagCustom) {
        var vm = this;

        vm.loadPage = loadPage;
        //vm.predicate = pagingParams.predicate;
        //vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        //vm.searchQuery = pagingParams.search;
        //vm.currentSearch = pagingParams.search;
        vm.orderBagFinalPrice = [];
        vm.approve = approve;
        vm.orderBag = null;
        vm.formState = 'noitem';
        //loadAll();

        loadActiveOrderBagItems();


        function loadAll() {
            if (pagingParams.search) {
                OrderBagServiceItemSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                OrderBagServiceItem.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.orderBagServiceItems = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadActiveOrderBagItems() {

            OrderBagServiceItemCustom.getActiveOrderBagServiceItems().query(function (result) {
                vm.orderBagServiceItems = result;
                if (vm.orderBagServiceItems != null && vm.orderBagServiceItems.length != 0 && vm.orderBagServiceItems != undefined) {
                    vm.formState = 'active';
                    computeFinalPrice();
                } else {
                    vm.formState = 'noitem';
                }
            });

        }

        function computeFinalPrice() {

            var totalServicePrice = 0;
            var totalOptionPrice = 0;
            var totalVat = 0;
            var totalDiscount = 0;
            var finalPrice = 0;


            if (vm.orderBagServiceItems != null && vm.orderBagServiceItems.length != 0 && vm.orderBagServiceItems != undefined) {
                angular.forEach(vm.orderBagServiceItems, function (ob) {

                    if (ob.subtotalServicePrice != null)
                        totalServicePrice += ob.subtotalServicePrice;
                    if (ob.subtotalOptionPrice != null)
                        totalOptionPrice += ob.subtotalOptionPrice;
                    if (ob.subtotalVAT != null)
                        totalVat += ob.subtotalVAT;
                    if (ob.subtotalDiscount != null)
                        totalDiscount += ob.subtotalDiscount;
                });

                finalPrice = totalServicePrice + totalOptionPrice - totalDiscount + totalVat;

            }


            vm.orderBagFinalPrice.totalServicePrice = totalServicePrice;
            vm.orderBagFinalPrice.totalOptionPrice = totalOptionPrice;
            vm.orderBagFinalPrice.totalDiscount = totalDiscount;
            vm.orderBagFinalPrice.totalVat = totalVat;
            vm.orderBagFinalPrice.finalPrice = finalPrice;

        }

        function approve() {
            if (vm.orderBagServiceItems != null || vm.orderBagServiceItems.size != 0 || vm.orderBagServiceItems != undefined) {
                if (vm.orderBagServiceItems[0].orderBagId != null) {
                    OrderBagCustom.approveOrderBag(vm.orderBagServiceItems[0].orderBagId).query(function (result) {
                        vm.orderBag = result;
                        vm.formState = 'confirmed';
                    });
                }
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
